



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import checkout from '@/store/modules/checkout';
import { Address, QuoteAddress } from '@/store/models';
import addressNormalizer from '@/commons/addressNormalizer';
import cart from '@/store/modules/cart';
import AddressForm from '@/components/Address/Form.vue';
import store from '@/store';
import { getFullUrl } from '@/commons/redirectManager';
import addressValidator from '@/commons/addressValidator';
import { err } from '@/commons/toast';
import handleMessage from '@/commons/messageManager';

@Component({
    components: {
        AddressForm,
    },
})
export default class AddressList extends Vue {
    private editAddressFlag: boolean = false;
    private editAddressId: number | null = null;
    @Prop() private type!: string;

    get selectedAddressId(): number {
        return checkout.selectedAddressId[this.type];
    }

    set selectedAddressId(val: number) {
        checkout.setSelectedAddressId({ type: this.type, id: val });
    }

    get addresses(): Address[] {
        if (!this.isLogged && this.type === 'shipping' && checkout.shippingAddress.id) {
            return user.customer.addresses
                .filter((a, index, self) => index === self.findIndex((t) => t.id === a.id))
                .filter((address) => address.id === checkout.shippingAddress.id)
                .sort((a, b) => (a.id > b.id ? 1 : -1));
        }

        if (!this.isLogged && this.type === 'billing') {
            return user.customer.addresses
                .filter((a, index, self) => index === self.findIndex((t) => t.id === a.id))
                .filter((address) => address.id !== checkout.shippingAddress.id)
                .sort((a, b) => (a.id > b.id ? 1 : -1));
        }

        return user.customer.addresses
            .filter((a, index, self) => index === self.findIndex((t) => t.id === a.id))
            .sort((a, b) => (a.id > b.id ? 1 : -1));
    }

    get isLoading(): boolean {
        return cart.loadingFlags.totals;
    }

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get isItalianStore(): boolean {
        return store.state.options.store_code === 'it_it';
    }

    private mounted() {
        this.addresses.forEach((address) => {
            if (this.isSelected(address)) {
                this.selectAddress(address);
            }
        });
    }

    private isSelected(address: Address) {
        const errors = addressValidator(address);
        if (errors.length > 0) {
            address.error = true;
        }
        if (this.selectedAddressId && address.id === this.selectedAddressId) {
            return true;
        }

        if (!this.selectedAddressId) {
            if (this.type === 'shipping') {
                if (checkout.shippingAddress.customer_address_id) {
                    return address.id === checkout.shippingAddress.customer_address_id;
                }
            } else if (this.type === 'billing') {
                if (checkout.billingAddress.customer_address_id) {
                    return address.id === checkout.billingAddress.customer_address_id;
                }
            }
        }

        return false;
    }

    private selectAddress(address: Address, event: any = null) {
        const errors = addressValidator(address);
        if (errors.length > 0) {
            if (event) {
                event.preventDefault();
            }
            if (this.isLogged) {
                const link = getFullUrl(`/customer/address/edit/id/${address.id}/`);
                err(
                    `${this.$t('Selected address has invalid fields').toString()}:<br>${errors.join(', ')}<br>${this.$t(
                        '<a href="{link}">Edit it</a> or insert/select another one',
                        { link },
                    ).toString()}`,
                );
            } else {
                handleMessage('error', `${this.$t('Selected address has invalid fields').toString()}`);
            }

            address.error = true;
        } else {
            this.selectedAddressId = address.id;
            const customerAddress = addressNormalizer(address);
            delete customerAddress.id;
            user.resetAddressErrors();
            this.$emit('addressSelected', customerAddress);
        }
    }

    private closeEditAddress(address: QuoteAddress) {
        this.selectAddress(address);
        this.editAddressFlag = false;
    }

    private addressFromId(id: number | null): Address | undefined {
        return user.customer.addresses.find((address) => address.id === id);
    }

    private getAddressEditUrl(addressId: number): string {
        return getFullUrl(`/customer/address/edit/id/${addressId}`);
    }
}
